<template>
  <el-dialog
    :title="L10n('add-new-activity')"
    :visible="true"
    custom-class="dialog-short-form"
    :closeOnClickModal="false"
    append-to-body
    @close="handleDialogClose"
  >
    <div v-loading="isLoading">
      <form-new
        ref="form"
        :model="getModel"
        :data="data"
      />
    </div>
    <form-controls
      isCancel
      isCreate
      @command="handlerCommand"
    ></form-controls>
  </el-dialog>
</template>

<script>

export default {
  name: 'ModalNew',
  components: {
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls'),
    'form-new': () => import(/* webpackChunkName: 'LogList' */ './FormNew')
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      data: {}
    }
  },
  methods: {
    getModel () {
      return {
        description: ''
      }
    },
    handleDialogClose () {
      this.$emit('onClose', false)
    },
    async validate () {
      return this.$refs['form'].validate()
    },
    async handlerCommand (command) {
      if (command === 'cancel') {
        this.handleDialogClose()
      }
      if (command === 'save') {
        try {
          await this.validate()
          this.$emit('onCreate', { ...this.$refs['form'].getData() })
        } catch (e) {
          this.validateErrorHandler(e)
        }
      }
    }
  }
}
</script>
